import { get, post, patch, del } from './client.js';

const base = (orgId) => `/orgs/${orgId}/channels`;

export const orgChannelsApi = {
  list: (orgId) => get(base(orgId)),
  stats: (orgId) => get(`${base(orgId)}/stats`),
  get: (orgId, channelId) => get(`${base(orgId)}/${channelId}`),
  health: (orgId, channelId) => get(`${base(orgId)}/${channelId}/health`),
  connect: (orgId, data) => post(base(orgId), data),
  update: (orgId, channelId, data) => patch(`${base(orgId)}/${channelId}`, data),
  test: (orgId, channelId) => post(`${base(orgId)}/${channelId}/test`),
  disconnect: (orgId, channelId) => post(`${base(orgId)}/${channelId}/disconnect`),
  reconnect: (orgId, channelId) => post(`${base(orgId)}/${channelId}/reconnect`),
  remove: (orgId, channelId) => del(`${base(orgId)}/${channelId}`),
};
